export default __webpack_public_path__ + "static/media/cloud.a337a544.svg";